import styled from '@emotion/styled';
import { ellipsis } from '@styles/mixin';
import { baseSpacing, baseStyles } from './config';

export const Container = styled.div`
  position: relative;
  height: 100%;
  margin: 0 auto;
  :hover .ch-nameplate {
    display: block;
  }

  video {
    border-radius: 5px;
    max-width: 100%;
    height: 100%;
  }

  .ch-icon {
    display: inline-block;
    flex: 0 0 1.5rem;
    margin-right: 0.5rem;
    background-color: papayawhip;
    width: 1.5rem;
    height: 1.5rem;
  }

  .ch-nameplate {
    display: none;
    position: absolute;
    bottom: 0.25rem;
    left: 0.25rem;
    margin: 0 auto;
    border-radius: 0.25rem;
    padding: 0.2rem;
    width: 90%;
    color: #ffffff;
    text-align: left;

    div {
      ${ellipsis};
      display: flex;
      align-items: center;
    }

    .ch-text {
      margin: 0;
      overflow: hidden;
      font-size: 14px;
      text-overflow: ellipsis;
      text-shadow: 0px 0px 3px rgba(33, 37, 41, 0.95);
      white-space: nowrap;
    }
  }

  .ch-status {
    display: flex;
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    align-items: center;
    gap: 0.25rem;
  }

  .ch-status-icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ${baseSpacing}
  ${baseStyles}
`;

export const DotWrap = styled.div`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
  width: 24px;
  height: 24px;
  background-color: #49c4ab;
  border-radius: 50%;
`;

export const Dot = styled.div<{ volume: number }>`
  width: 4px;
  height: 4px;
  background-color: #ffffff;
  transition: transform 0.15s;
  border-radius: 50%;
  transform: scaleY(${(props) => props.volume});
`;

export const NameplatePeerScreen = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #1f1f1f;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
`;

export const NameplateScreen = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #1f1f1f;
  border: 1px solid #495057;
  border-radius: 4px;
`;

export const NameplateScreenName = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 33%;
  min-height: 100px;
  background-color: #2e2f34;
  border-radius: 50%;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  aspect-ratio: 1/1;
`;
